/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetAuthClientHeadersRequestBody,
  SetAuthClientHeadersRequestBody$Outbound,
  SetAuthClientHeadersRequestBody$outboundSchema,
} from "../components/setauthclientheadersrequestbody.js";

export type SetAuthClientHeadersSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type SetAuthClientHeadersRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  setAuthClientHeadersRequestBody: SetAuthClientHeadersRequestBody;
};

/** @internal */
export type SetAuthClientHeadersSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const SetAuthClientHeadersSecurity$outboundSchema: z.ZodMiniType<
  SetAuthClientHeadersSecurity$Outbound,
  SetAuthClientHeadersSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
    apikeyHeaderGramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
    });
  }),
);

export function setAuthClientHeadersSecurityToJSON(
  setAuthClientHeadersSecurity: SetAuthClientHeadersSecurity,
): string {
  return JSON.stringify(
    SetAuthClientHeadersSecurity$outboundSchema.parse(
      setAuthClientHeadersSecurity,
    ),
  );
}

/** @internal */
export type SetAuthClientHeadersRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  SetAuthClientHeadersRequestBody: SetAuthClientHeadersRequestBody$Outbound;
};

/** @internal */
export const SetAuthClientHeadersRequest$outboundSchema: z.ZodMiniType<
  SetAuthClientHeadersRequest$Outbound,
  SetAuthClientHeadersRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    setAuthClientHeadersRequestBody:
      SetAuthClientHeadersRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      setAuthClientHeadersRequestBody: "SetAuthClientHeadersRequestBody",
    });
  }),
);

export function setAuthClientHeadersRequestToJSON(
  setAuthClientHeadersRequest: SetAuthClientHeadersRequest,
): string {
  return JSON.stringify(
    SetAuthClientHeadersRequest$outboundSchema.parse(
      setAuthClientHeadersRequest,
    ),
  );
}
